import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';



 // Product filters

new Vue({
  el: '#productfilters',
  data: {
    question: '',
    cat: '',
    producttype: '',
    viewtype: 'list',
    lang: '',
    answer: '',
    result: '',
    number: '',
    loader: false,
    url: '/wp-json/products_endpoint/v1/product',

  },
  mounted() {
    this.lang = this.$refs.lang.dataset.value;


    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);

    if(params.get("question") !== null){
      this.question = params.get("question");
    }

    if(params.get("producttype") !== null){
      this.loader = true
      this.producttype = params.get("producttype");
      this.getResult();
    }
    if(params.get("producttype") !== null && ( params.get("cat") !== null || params.get("number") !== null ) ){
        this.loader = true
        this.producttype = params.get("producttype");
        this.cat = params.get("cat");
        this.number = params.get("number");
        this.getResult();
    }

  },
  watch: {
    // whenever question changes, this function will run
    question: function (newQuestion) {
      // this.result = ''

      this.loader = true
      this.getResult()

      if(this.question == ''){
        this.result = ''
      }
    },
    cat: function (newCat) {
      // this.result = ''
      if(this.cat !== null){
        this.loader = true
        this.getResult()
      }
    },
    number: function () {
      // this.result = ''
      if(this.number !== null){
      this.loader = true
      this.getResult()
      }
    }
  },
  methods: {
    getResult: _.debounce(

      function () {

        if (typeof history.pushState !== "undefined") {
          const query = [];


          if (this.question && this.question !== "") {
            query.push(`question=${this.question}`);
          }

          if (this.producttype && this.producttype !== "") {
            query.push(`producttype=${this.producttype}`);
          }

          if (this.cat && this.cat !== "") {
            query.push(`cat=${this.cat}`);
          }

          if (this.number && this.number !== "") {
            query.push(`number=${this.number}`);
          }

          history.pushState(
            {}, document.title,
            `${window.location.origin}${window.location.pathname}` + query.length ? `?${query.join('&')}` : ''
          );
        }


        if (this.question || this.cat || this.producttype) {

          var cat_array = ''
          var cat = ''
          var number = ''

          if( this.cat == '' &&  this.producttype !== '' ){
              cat_array = this.producttype
          }
          if( this.cat !== null ){
            cat = this.cat
          }
          if( this.number !== null ){
            number = this.number
          }

          var vm = this
          var searchUrl = this.url + '?&s=' + this.question  + '&lang=' + this.lang + '&cat=' + cat + '&cat_array=' + cat_array + '&number=' + number
          axios.get(searchUrl)
            .then(function (response) {


              // all results vm.result = response.data

              // Only uniq titled servieces

              vm.result = _.uniqWith(
                response.data,
                (respA, respB) =>
                  respA.post_title === respB.post_title &&
                  respA.product_companyname === respB.product_companyname
              );



              vm.loader = false

              if(vm.viewtype == 'map'){
                vm.initMap()
              }

            })
            .catch(function (error) {
              vm.answer = error
            })
        } else {

          this.loader = false
          this.result = ''

          if(this.viewtype == 'map'){
            initMap()
          }

          // var vm = this
          // var searchUrl = this.url
          // axios.get(searchUrl)
          //   .then(function (response) {
          //     vm.result = response.data
          //     vm.answer = ''
          //     vm.loader = false

          //     if(vm.viewtype == 'map'){
          //       vm.initMap()
          //     }

          //   })
          //   .catch(function (error) {
          //     vm.answer = error
          //   })
        }
      },
      // This is the number of milliseconds we wait for the user to stop typing.
      500
    ),
    cancel: function () {
      // let's make the field empty
      this.loader = true
      this.question = ''
      this.cat = ''
      this.producttype = ''
      this.number = ''
      this.viewtype = 'list'


      this.getResult()


    },

    empty: function () {
      // let's make the field empty
      this.loader = true
      this.question = ''

      this.getResult()

    },

    setProductType: function (value) {
      this.loader = true
      this.producttype = value
      this.cat = ''
      this.number = ''
      this.getResult()

    },
    setViewType: function (value) {
      this.viewtype = value

      if(value == 'map'){
        this.getResult()
      }

    },
    initMap: function () {




      var mapOptions = {
        center: new google.maps.LatLng(61.8715635, 25.1745752),
        zoom: 10,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        mapTypeId: 'roadmap'
      }
      var map = new google.maps.Map(document.getElementById("bigmap"), mapOptions);


      var key = 1
      var infowindow =  new google.maps.InfoWindow({});
      var bounds  = new google.maps.LatLngBounds();

      this.result.forEach(function (nObj) {
        let title = nObj.post_title
        let lat = nObj.lat
        let lng = nObj.lng
        let link = nObj.link
        let companyname = nObj.product_companyname
        let featured_image = nObj.featured_image
        let product_short_desc = nObj.product_short_desc

        if( lat !== '0' && lng !== '0' ){

          var loc = new google.maps.LatLng(lat, lng)

          var marker = new google.maps.Marker({
            position: loc,
            map: map,
            title: title
          });

          bounds.extend(loc);

          google.maps.event.addListener(marker, 'click', (function (marker, key) {


            return function () {

             // var content = '<img width="300px" src="'+featured_image+'" /><br /><br /><small>'+companyname+'</small><br /><h5 class="text-xl">'+ title +'</h5><small class="w-48 block">'+product_short_desc+'</small><br /><a class="arrow-link" href="' + link + '">Lue lisää</a>'

             var content = '<div class="flex"><div class="w-32 h-32 bg-cover bg-center" style="background-image: url(' + featured_image + ')"></div><div class="w-48 pl-2"><small>'+companyname+'</small><br /><h5 class="text-xl m-0">'+ title +'</h5><small class="block">'+product_short_desc+'</small><a class="text-primary font-heading mt-2 inline-block" href="' + link + '">Lue lisää</a></div></div>';

              infowindow.setContent(content);
              infowindow.open(map, marker);


            }
          })(marker, key));

          key = key + 1;

        }

      })



      map.fitBounds(bounds)
      map.panToBounds(bounds)


    },
  }
})
